/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_about_section_scoring = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy — Scoring Methodology`)
};

const es_about_section_scoring = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy — Metodología de puntuación`)
};

const de_about_section_scoring = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy — Bewertungsmethodik`)
};

const nl_about_section_scoring = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy — Scoremethodologie`)
};

const fr_about_section_scoring = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy — Méthodologie de notation`)
};

const it_about_section_scoring = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy — Metodologia di punteggio`)
};

const pt_br2_about_section_scoring = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy — Metodologia de pontuação`)
};

const pt_about_section_scoring = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy — Metodologia de pontuação`)
};

const ja_about_section_scoring = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1ファンタジー — スコアリング方法`)
};

const zh_about_section_scoring = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1梦幻赛车 — 评分方法`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const about_section_scoring = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.about_section_scoring(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("about_section_scoring", locale)
	if (locale === "en") return en_about_section_scoring(inputs)
	if (locale === "es") return es_about_section_scoring(inputs)
	if (locale === "de") return de_about_section_scoring(inputs)
	if (locale === "nl") return nl_about_section_scoring(inputs)
	if (locale === "fr") return fr_about_section_scoring(inputs)
	if (locale === "it") return it_about_section_scoring(inputs)
	if (locale === "pt-BR") return pt_br2_about_section_scoring(inputs)
	if (locale === "pt") return pt_about_section_scoring(inputs)
	if (locale === "ja") return ja_about_section_scoring(inputs)
	return zh_about_section_scoring(inputs)
};